import {
  GetServerAuditTrailRequest,
  GetServerAuditTrailResponse
} from "../../../domain/repositories/ConfigRepository";

import {
  TRIGGER_GET_SERVER_AUDIT_TRAIL,
  TriggerGetServerAuditTrail,

  GET_SERVER_AUDIT_TRAIL_PENDING,
  GetServerAuditTrailPending,

  GET_SERVER_AUDIT_TRAIL_SUCCESS,
  GetServerAuditTrailSuccess,

  GET_SERVER_AUDIT_TRAIL_ERROR,
  GetServerAuditTrailError,

  RESET_GET_SERVER_AUDIT_TRAIL,
  ResetGetServerAuditTrail
} from "./types";

export const triggerGetServerAuditTrail = (
  request: GetServerAuditTrailRequest
): TriggerGetServerAuditTrail => {
  return {
    type: TRIGGER_GET_SERVER_AUDIT_TRAIL,
    payload: { request }
  };
};

export const getServerAuditTrailPending = (): GetServerAuditTrailPending => {
  return {
    type: GET_SERVER_AUDIT_TRAIL_PENDING
  };
};

export const getServerAuditTrailSuccess = (
  response: GetServerAuditTrailResponse
): GetServerAuditTrailSuccess => {
  return {
    type: GET_SERVER_AUDIT_TRAIL_SUCCESS,
    payload: { response }

  };
};

export const getServerAuditTrailError = (): GetServerAuditTrailError => {
  return {
    type: GET_SERVER_AUDIT_TRAIL_ERROR,
  };
};

export const resetGetServerAuditTrail = (): ResetGetServerAuditTrail => {
  return {
    type: RESET_GET_SERVER_AUDIT_TRAIL,
  };
};